import React from "react";
import {Button, CardActions} from "@material-ui/core";
import {KeyboardBackspaceSharp} from "@material-ui/icons";
import generateSignUpUrl from "view/apps/Organiser/pages/Settings/EmbeddedShowList/components/ShowCard/LinkButton/helpers";
import {useParams} from "react-router-dom";
import {IEmbeddedShow} from "@evennt-tech/api-v2-core";

type Props = {showId: string} & Pick<
  IEmbeddedShow,
  "buttonColor" | "buttonTextColor"
>;

const LinkButton = ({showId, buttonColor, buttonTextColor}: Props) => {
  const {token} = useParams();
  const signUpUrl = generateSignUpUrl(showId, token);

  return (
    <CardActions>
      <Button
        target="_blank"
        href={signUpUrl || undefined}
        component="a"
        color="primary"
        variant="contained"
        fullWidth
        style={{
          ...(buttonColor && {backgroundColor: buttonColor}),
          ...(buttonTextColor && {color: buttonTextColor}),
        }}
      >
        Shop Now
        <KeyboardBackspaceSharp
          style={{
            transform: "rotate(180deg)",
            marginLeft: 8,
            ...(buttonTextColor && {color: buttonTextColor}),
          }}
        />
      </Button>
    </CardActions>
  );
};

export default LinkButton;
